<script lang="ts">
    import { onMount } from "svelte"
    import { apiBaseURL } from "../../config"
    import { navigate } from "svelte-routing"
    import { temperature } from "../stores"
    export let siteId
    let container
    let videoElements = []
    let videoTexts = []
    let videoWrappers = []
    let cooldown = false
    export let col

    onMount(() => {
        container.style.height = videoElements[0].offsetHeight + "px"
        Array.from(videoElements).forEach((e) => {
            e.style.height = "100%"
        })
        videoElements[0].play()
        videoElements[1].play()
        setTimeout(() => {
            videoElements[1].pause()
        }, 0)
        videoWrappers.forEach((videoWrapper) => {
            const video = videoWrapper.querySelector(".video")
            let eventFunc = (e) => {
                if (cooldown) return
                let selected = e.currentTarget
                cooldown = true
                setTimeout(() => {
                    cooldown = false
                }, 502)
                let text = selected.querySelector(".text")
                videoWrappers.forEach((vw) => {
                    if (selected == vw) {
                        vw.classList.add("video-wrapper-big")
                        vw.classList.remove("video-wrapper-small")
                    } else {
                        vw.classList.add("video-wrapper-small")
                        vw.classList.remove("video-wrapper-big")
                    }
                    vw.querySelector(".video").pause()
                })
                videoTexts.forEach((vt) => {
                    if (text == vt) {
                        setTimeout(() => {
                            vt.classList.add("shown")
                            vt.classList.remove("hidden")
                        }, 500)
                    } else {
                        vt.classList.add("hidden")
                        vt.classList.remove("shown")
                    }
                })
                video.play()
            }

            videoWrapper.addEventListener("mousemove", (e) => eventFunc(e))
            videoWrapper.addEventListener("click", (e) => eventFunc(e))
        })
    })
    let innerWidth = window.innerWidth
</script>

<div class="video-top-lvl-container">
    <div id="wrapper" class="video-container" bind:this="{container}">
        <div class="video-wrapper video-wrapper-big" bind:this="{videoWrappers[0]}">
            <div class="text shown" bind:this="{videoTexts[0]}">
                <h2>{col.videoSwitch[0]?.title}</h2>
                <p>
                    {col.videoSwitch[0]?.description}
                </p>
                <button
                    class="link"
                    on:click="{() => {
                        navigate(col.videoSwitch[0]?.link)
                    }}">MEHR</button
                >
            </div>
            <video
                class="video"
                playsinline
                src="{`${apiBaseURL}content/${siteId}/${col.videoSwitch[0].video?.src}`}"
                loop
                alt="video1"
                muted
                bind:this="{videoElements[0]}"><track kind="captions" /></video
            >
        </div>
        <div class="video-wrapper video-wrapper-small" bind:this="{videoWrappers[1]}">
            <div class="text hidden" bind:this="{videoTexts[1]}">
                <h2>{col.videoSwitch[1]?.title}</h2>
                <p>
                    {col.videoSwitch[1]?.description}
                </p>
                <button
                    class="link"
                    on:click="{() => {
                        navigate(col.videoSwitch[1]?.link)
                    }}">MEHR</button
                >
            </div>
            <video
                class="video"
                loop
                playsinline
                src="{`${apiBaseURL}content/${siteId}/${col.videoSwitch[1].video?.src}`}"
                muted
                bind:this="{videoElements[1]}"><track kind="captions" /></video
            >
        </div>
    </div>
    <div class="icons">
        <button class="thermo">
            <img src="/media/thermometer.svg" alt="temp" />
            {Number($temperature).toFixed(1) || "-"} °C
        </button>
    </div>
</div>

<style lang="less">
    @import "../assets/css/variables.less";

    .video-top-lvl-container {
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: 40px;
    }

    .video-container {
        display: flex;
        width: 100%;
        @media @mobile {
            gap: 20px;
        }
        @media @tablet {
            gap: 40px;
        }
    }
    .icons {
        display: flex;
        width: 100%;
        @media @mobile {
            justify-content: end;
        }
        @media @tablet {
            justify-content: end;
            button {
                margin: 28px 2rem !important;
            }
        }
        margin-bottom: 60px;

        img {
            transform: scale(1.5);
            margin: 0px 0.4rem;
        }
        button {
            display: flex;
            font-weight: bold;
            justify-content: center;
            font-size: 1rem;
            position: relative;
            margin: 0 1rem;
        }
        button::before {
            font-weight: 400;
            position: absolute;
            transform: translateY(-150%);
        }
        .camera::before {
            content: "Webcam";
        }
        .thermo::before {
            content: "Lufttemperatur";
        }
        .waves::before {
            content: "Wassertemperatur";
        }
    }

    .video-wrapper {
        overflow: hidden;
        position: relative;
        &::before {
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, 0.3);
            z-index: 10;
        }
        @media @mobile {
            .hidden {
                p,
                button {
                    visibility: hidden !important;
                    opacity: 0;
                    height: 0px;
                    margin-top: 0px !important;
                    transition: opacity 0s;
                }
                h2 {
                    margin-bottom: 0px !important;
                    transform: translateY(50%);
                }
            }

            .shown {
                opacity: 1;
                visibility: visible;
            }
        }
        @media @desktop {
            .hidden {
                h2 {
                    visibility: hidden;
                    transition: opacity 0s;
                }
            }
        }
        .text {
            position: absolute;
            z-index: 20;
            max-width: 85%;
            color: rgb(255, 255, 255);
            animation-delay: 500ms;
            bottom: 35px;
            left: 35px;

            @media @mobile {
                h2 {
                    font-size: 2.8rem;
                    font-weight: bold;
                    line-height: normal;
                    margin-bottom: 5px;
                }
                p {
                    line-height: normal;
                }

                button {
                    border-top: 3px solid white;
                    font-weight: bold;
                    padding-top: 2px;
                    color: white;
                    font-size: 16px;
                    margin-top: 15px;
                }
            }
            @media @desktop {
                max-width: 70%;
                h2 {
                    font-size: 2.7rem;
                }
                p {
                }

                button {
                    font-size: 24px;
                }
            }
        }
    }

    .video {
        width: 100%;
        min-height: max(35vh, 400px);
        height: auto;
        object-fit: cover;
        position: absolute;
        top: 0;
        left: 0;
    }

    .video-wrapper-big {
        flex: 3;
    }

    .video-wrapper-small {
        flex: 1 !important;
    }

    .video-wrapper-big:hover,
    .video-wrapper-small:hover {
        flex: 3;
    }

    @media (max-width: 1023px) {
        .video-container {
            flex-direction: column;
        }

        .text {
            max-width: 90%;
        }

        video {
            height: 100% !important;
            min-height: 75vh !important;
            width: auto !important;
            min-width: 100%;
            object-fit: cover;
            object-position: center;
        }

        .video-wrapper-small,
        .video-wrapper-big {
            width: 100%;
        }
    }
</style>
